import { getConfig } from '@leagueplatform/config';

declare global {
  interface Window {
    setMirrordRoute?: (value?: string) => string;
    getMirrordRoute?: () => string | null;
  }
}

const BASE_STORAGE_KEY = 'LEAGUE_MIRRORD_ROUTE';

function getEnvAndTenant() {
  const cfg = getConfig(false);
  const config = cfg?.config;
  const appEnvironment = config?.core?.appEnvironment;
  const tenantId = config?.core?.tenantId;
  return { appEnvironment, tenantId };
}

function getStorageKey() {
  const { appEnvironment, tenantId } = getEnvAndTenant();
  return `${BASE_STORAGE_KEY}${appEnvironment ? `:${appEnvironment}` : ''}${
    tenantId ? `:${tenantId}` : ''
  }`;
}

export function setMirrordRoute(value?: string): string {
  const storageKey = getStorageKey();
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    localStorage.removeItem(storageKey);
    return 'League Mirrord Route Cleared';
  }
  localStorage.setItem(storageKey, trimmed);
  return `League Mirrord Route Set to "${trimmed}"`;
}

export function getMirrordRoute(): string | null {
  const storageKey = getStorageKey();
  return localStorage.getItem(storageKey);
}

/**
 * Attaches developer helpers to window in non-production environments:
 * - window.setMirrordRoute(value?: string)
 * - window.getMirrordRoute(): string | null
 *
 * These helpers read/write a namespaced localStorage key so values are scoped
 * per environment and tenant.
 */
export function setupMirrordRouteDevUtils() {
  if (typeof window === 'undefined') return;
  const { appEnvironment } = getEnvAndTenant();
  if (appEnvironment === 'production') return;

  if (!window.setMirrordRoute) {
    window.setMirrordRoute = setMirrordRoute;
  }
  if (!window.getMirrordRoute) {
    window.getMirrordRoute = getMirrordRoute;
  }
}
